import 'jquery';
import { Header } from './header';
import { CookiePolicy } from './cookiepolicy';
import { Modal } from './modal';
import { Cookie2 } from './cookie2';
import { Loader } from './loader';
import { Components } from './components';
import * as utils from './utils';
import { ajax } from './ajax';

/*
* Observer! In setUserInformation it creates html in menu that calls JavaScript.
*           That JavaScript relies of global objects exist:
*           window.unify.cookiePolicy
*           window.unify.termsOfService
*           window.unify.dataProcessingDeclaration
*           window.unify.contact
*/

/**
* In the users.ts file all the user related information in Unify is stored.
*/

/**
* User class is used in Unify to store information about logged in user as currentUser:
* @example 
*       create the currentUser object from email firstName lastName and userName
*          unify.currentUser = new window.unify.User('Petronella', 'Persson', 'petper', 'petronella.persson@soderbergpartners.se');
*/
export class User {
    // defaults to anonymous user without user email and username
    constructor(o) {
        o = typeof o !== 'undefined' ? o : {};
        this.firstName = typeof o.firstName !== 'undefined' ? o.firstName : '';
        this.lastName = typeof o.lastName !== 'undefined' ? o.lastName : '';
        this.userName = typeof o.userName !== 'undefined' ? o.userName : '';
        this.email = typeof o.email !== 'undefined' ? o.email : '';
        this.isImpersonated = typeof o.isImpersonated !== 'undefined' ? o.isImpersonated : false;
        this.impersonatorFullName = typeof o.impersonatorFullName !== 'undefined' ? o.impersonatorFullName : '';
        this.canImpersonate = typeof o.canImpersonate !== 'undefined' ? o.canImpersonate : false;

        this.endpoints = typeof o.endpoints !== 'undefined' ? o.endpoints : '';
        this.translations = typeof o.translations !== 'undefined' ? o.translations : '';

        this.fullName = this.firstName + ' ' + this.lastName;
        this.hasGivenCookieConsent = false;
        this.isAuthenticated = false;
        this.sessionCookieName = null;
        this.authenticationLevel = null;

        this.SessionCookieStatus = {
            Ok: 1,
            Invalid: 2,
            AboutToExpire: 3,
            Expired: 4
        };
    }

    /**
    * setUserInformation update user information from Unify
    * @param {undefined|object} json is the user information content in json format.
    * @example call
    *  setUserInformation( { FullName: 'Petronella Persson', CanLogout: false, LogoutUrl: null } );
    */
    setUserInformation(json) {
        json = typeof json === "undefined" ? {} : json;
        var fullName = typeof json.FullName === "undefined" || json.FullName === null ? "" : json.FullName.trim();
        var isLoggedIn = typeof json.IsLoggedIn === "undefined" || json.IsLoggedIn === null ? false : json.IsLoggedIn;
        var authenticationLevel = typeof json.AuthenticationLevel === "undefined" || json.AuthenticationLevel === null ? null : json.AuthenticationLevel;

        var isImpersonated = typeof json.IsImpersonated === "undefined" || json.IsImpersonated === null ? false : json.IsImpersonated;
        var impersonatorFullName = typeof json.ImpersonatorFullName === "undefined" || json.ImpersonatorFullName === null ? "" : json.ImpersonatorFullName;
        var canImpersonate = typeof json.CanImpersonate === "undefined" || json.CanImpersonate === null ? false : json.CanImpersonate;
        var hasGivenCookieConsent = typeof json.HasGivenCookieConsent === "undefined" || json.HasGivenCookieConsent === null ? false : json.HasGivenCookieConsent;
        var sessionCookieName = typeof json.SessionCookieName === "undefined" || json.SessionCookieName === null ? "" : json.SessionCookieName;
        var documentsUri = typeof json.DocumentsUri === "undefined" || json.DocumentsUri === null ? "" : json.DocumentsUri;
        var profileUri = typeof json.ProfileUri === "undefined" || json.ProfileUri === null ? "" : json.ProfileUri;
        var casesUri = typeof json.MyCasesUri === "undefined" || json.MyCasesUri === null ? "" : json.MyCasesUri;

        // update currentUser
        this.isAuthenticated = isLoggedIn;
        this.sessionCookieName = sessionCookieName;
        this.authenticationLevel = authenticationLevel;
        this.fullName = fullName;
        if (fullName.indexOf(' ') !== -1) {
            var indexFirstSpace = fullName.indexOf(' ');
            this.firstName = fullName.substr(0, indexFirstSpace);
            this.lastName = fullName.substr(indexFirstSpace + 1);
        }
        this.canImpersonate = canImpersonate;
        this.impersonatorFullName = impersonatorFullName;
        this.isImpersonated = isImpersonated;

        // Update cookie consent info.
        this.hasGivenCookieConsent = hasGivenCookieConsent;

        // remove possible login li
        $('.unify-header-login-li').remove();

        var header = new Header({
            translations: this.translations
        });

        // update all layout where userinformation is used
        if (isLoggedIn) {
            // hide the login
            $('.unify-header-login').addClass('unify-hidden');
            // show the user drop
            $('.unify-header-user-drop').removeClass('unify-hidden');

            var logout = this.translations.internal.SignOutLinkText;
            var changePassword = this.translations.internal.ChangePasswordLink;
            var impersonateUser = this.translations.internal.ImpersonateUserLinkText;

            var objects = [];

            objects.push({ html: '<li><a href="' + profileUri + '" id="unify-usermenu-profile">' + this.translations.internal.MyProfileLinkText + '</a></li>' });
            objects.push({ html: '<li><a href="' + documentsUri + '" id="unify-usermenu-documents">' + this.translations.internal.MyDocumentsLinkText + '</a></li>' });
            objects.push({ html: '<li><a href="' + casesUri + '" id="unify-usermenu-cases">' + this.translations.internal.MyCasesLinkText + '</a></li>' });

            if (isImpersonated === false) {
                objects.push({ html: '<li><a href="#" onclick="window.unify.showChangePassword();" id="unify-usermenu-changepassword">' + changePassword + '</a></li>' });
            }

            objects.push({ type: 'seperator' });

            // policy
            objects.push({ html: '<li><a onclick="window.unify.cookiePolicy.showModal();" id="unify-usermenu-cookiepolicy">' + this.translations.internal.CookiePolicyLinkText + '</a></li>' });
            // terms of service
            objects.push({ html: '<li><a onclick="window.unify.termsOfService.showModal();" id="unify-usermenu-tos">' + this.translations.internal.TermsOfServiceLink + '</a></li>' });
            // data processing declaration 
            objects.push({ html: '<li><a onclick="window.unify.dataProcessingDeclaration.showModal();" id="unify-usermenu-dpd">' + this.translations.internal.DataProcessingDeclarationLinkText + '</a></li>' });
            // contact
            objects.push({ html: '<li><a onclick="window.unify.contact.showModal();" id="unify-usermenu-contact">' + this.translations.internal.ContactInfoLinkText + '</a></li>' });

            objects.push({ type: 'seperator' });

            if (canImpersonate) {
                objects.push({ html: '<li><a href="#" onclick="window.unify.showImpersonateUser();" id="unify-usermenu-switchuser">' + impersonateUser + '</a></li>' });
            }

            if (isImpersonated) {
                objects.push({ html: '<li><div class="unify-header-impersonated-by">' + this.translations.internal.IsImpersonatedByText.replace('{Name}', impersonatorFullName) + '</div></li>' });
            }

            objects.push({ html: '<li><a href="#" onclick="window.unify.signout();" id="unify-usermenu-signout">' + logout + '</a></li>' });

            header.addTopBarRightUserLinks({
                append: false,
                objects: objects
            });
        } else {
            // hide the user drop
            $('.unify-header-user-drop').addClass('unify-hidden');
            // hide the notification drop
            $('.unify-header-notification-drop').addClass('unify-hidden');
            // show th login drop
            $('.unify-header-login').removeClass('unify-hidden');

            // add login html and show it
            var objects2 = [{ html: '<li><a href="#" onclick="window.unify.login.initiateLogin();";">' + this.translations.internal.SignInLinkText + '</a></li>' }];

            objects2.push({ type: 'seperator' });
            // policy
            objects2.push({ html: '<li><a onclick="window.unify.cookiePolicy.showModal();">' + this.translations.internal.CookiePolicyLinkText + '</a></li>' });
            // terms of service
            objects2.push({ html: '<li><a onclick="window.unify.termsOfService.showModal();">' + this.translations.internal.TermsOfServiceLink + '</a></li>' });
            // data processing declaration 
            objects2.push({ html: '<li><a onclick="window.unify.dataProcessingDeclaration.showModal();">' + this.translations.internal.DataProcessingDeclarationLinkText + '</a></li>' });
            // contact
            objects2.push({ html: '<li><a onclick="window.unify.contact.showModal();">' + this.translations.internal.ContactInfoLinkText + '</a></li>' });

            $('.unify-header-login').removeClass('unify-hidden');

            header.addTopBarRightUserLinks({
                append: false,
                objects: objects2,
                selector: '.dropdown-menu.unify-dropdown-login'
            });

        }
        // update layout
        header.updateTopBarWithUserInformation(this);
    }

    showChangePassword() {
        var msg = this.createChangePasswordHtml();
        this.showChangePasswordDialog(msg);
        this.addDebounceToChangePasswordSubmitButton();
        this.updateChangePasswordPolicy();
        this.addChangePasswordPolicyOnInputChange();
        this.addHideValidationMessageOnInputChange();
    }

    showImpersonateUser() {
        var msg = this.createImpersonateUserHtml();
        this.showImpersonateUserDialog(msg);
    }

    showAjaxErrorModal(o) {
        o = o === undefined ? {} : o;
        // set all parameters to the object, if not sent with the option possible default value is set.
        o.message = (typeof o.message === 'undefined') ? '' : o.message;
        o.title = (typeof o.title === 'undefined') ? undefined : o.title;

        var modal = new Modal();
        modal.title = o.title;
        modal.message = o.message;
        modal.closeText = this.translations.common.Close;
        modal.show();
    }

    updateImpersonateUserButtonDisabled(input) {
        this.getImpersonationSearchButton(input).prop('disabled', input.value.length <= 1);
    }

    updateImpersonateUserSelect(button) {
        var url = "/unify/impersonation/allowedimpersonations";

        var ajaxError500Title = '';
        var ajaxError500Message = this.translations.internal.ImpersonationSearchError || 'At the moment there are to many people accessing this feature, try again later';
        var select = this.getImpersonationInput(button);
        var selectId = $(select).attr('id');
        // always add selectivity to select because it is not possible to check if selectivity has been initialized
        $('#' + selectId)
            .selectivity({
                allowClear: true,
                items: [],
                inputType: 'UnifySingle'
            });

        // check if any value has been set, get
        var inputVal = this.getImpersonationSearchInputValue(button);
        if (inputVal === null || typeof inputVal === "undefined") {
            // no user selected
            return;
        }
        // min 2 letters
        if (inputVal.length <= 1) {
            return;
        }
        var loader = new Loader();
        loader.show(false, '');
        // get items from ajax
        $.ajax({
            context: this,
            method: "GET",
            url: url,
            dataType: "json",
            data: { searchString: inputVal, page: 1 },
            statusCode: {
                500: function () {
                    var loader = new Loader();
                    loader.hide();
                    this.context.showAjaxErrorModal({
                        message: ajaxError500Message,
                        title: ajaxError500Title
                    });
                }
            }
        })
            .done(function (msg) {
                var loader = new Loader();
                loader.hide();
                var items = $.map(msg.items, function (val) {
                    return { id: val.userId, text: val.displayName };
                });
                $(select).selectivity('clear');
                if (items.length >= 1) {
                    $(select).selectivity('setOptions', { 'items': items });
                    // make first object as selected
                    $(select).selectivity('value', items[0].id);
                }
            })
            .fail(function () {
                var loader = new Loader();
                loader.hide();
                this.context.showAjaxErrorModal({
                    message: ajaxError500Message,
                    title: ajaxError500Title
                });
            });
    }

    createImpersonateUserHtml() {
        var searchHeading = this.translations.internal.ImpersonationSearchBoxHeading || 'Search';
        var searchInputPlaceholder = this.translations.internal.ImpersonationSearchBoxPlaceholder || 'Name';
        var searchButtonText = this.translations.common.Search || 'Search';

        var userHeading = this.translations.internal.UserToImpersonateHeading;
        var switchToUserSelectHtml = '' +
            '<div class="form-group">' +
            '     <label for="unify-impersonate-user-search-input" class="form-control-label">' +
            searchHeading +
            '     </label>' +
            '     <input type= "text" class="form-control input-md" onkeyup="window.unify.updateImpersonateUserButtonDisabled(this)" id="unify-impersonate-user-search-input" placeholder="' + searchInputPlaceholder + '" >' +
            '     <button type="button" id="unify-impersonate-user-search" class="unify-impersonate-user-search-button btn btn-primary" onclick="window.unify.updateImpersonateUserSelect(this)">' + searchButtonText + '</button>' +
            '</div>' +
            '<div class="form-group" >' +
            '     <label for="unify-impersonate-user-input" class="form-control-label">' +
            userHeading +
            '     </label>' +
            '     <select id="unify-impersonate-user-input" name="unify-impersonate-user-input" type="text"></select>' +
            '</div>';
        return switchToUserSelectHtml;
    }

    getImpersonationSearchButton(itemInsideDialog) {
        var modal = $(itemInsideDialog).parents('.modal-content');
        var button = $('.unify-impersonate-user-search-button', modal);
        return button;
    }

    getImpersonationInput(itemInsideDialog) {
        var modal = $(itemInsideDialog).parents('.modal-content');
        var input = $('#unify-impersonate-user-input', modal);
        return input;
    }

    getImpersonationSearchInputValue(itemInsideDialog) {
        return this.getImpersonationSearchInput(itemInsideDialog).val();
    }
    getImpersonationSearchInput(itemInsideDialog) {
        return $('#unify-impersonate-user-search-input', $(itemInsideDialog).parents('.modal-content'));
    }

    getImpersonationInputValue(itemInsideDialog) {
        var input = this.getImpersonationInput(itemInsideDialog);
        return $(input).selectivity('value');
    }

    initiateImpersonation(switchUserButton) {
        var selectVal = this.getImpersonationInputValue(switchUserButton);
        if (selectVal === null) {
            // no user selected
            return;
        }

        // initiate the switchUser (Guid == impersonatedUserId)
        window.location.href = this.endpoints.ActivateImpersonationUri + '?impersonatedUserId=' + selectVal + '&redirectUri=' + window.location.href;
    }


    showImpersonateUserDialog(msg) {
        var options = { backdrop: 'static', keyboard: false, show: true };

        // check if the modal has been created (will have added data attribute impersonate-user, see below)
        for (var i = 0, nr = $('.modal').length; i < nr; i++) {
            var modal = $('.modal')[i];
            if ($(modal).data('impersonate-user') === true) {
                $(modal).modal(options);
                return modal;
            }
        }

        var impersonateUserSubmitButtonText = this.translations.internal.ImpersonateUserSubmitButtonText;
        var cancel = this.translations.common.Cancel;
        var footer = '<button type="button" id="unify-impersonate-user-cancel" class="btn btn-default" data-dismiss="modal">' + cancel + '</button><button type="button" id="unify-impersonate-user-initiate" onclick="window.unify.initiateImpersonation(this);" class="btn btn-primary">' + impersonateUserSubmitButtonText + '</button>';
        var impersonateUserModalHeading = this.translations.internal.ImpersonateUserModalHeading;
        var components = new Components();
        var dialog = components.createDialogHtml({ footer: footer, body: msg, title: impersonateUserModalHeading, tabIndex: '' });

        $('body').append(dialog.html);

        $('#' + dialog.id).modal(options);
        // add impersonate-user data attribute to be able to distinguish if there exist a impersonate-user modal created
        $('#' + dialog.id).data('impersonate-user', true);
        this.updateImpersonateUserSelect($('button', $('#' + dialog.id))[0]);
        this.updateImpersonateUserButtonDisabled($('#unify-impersonate-user-search-input', $('#' + dialog.id))[0]);

        return dialog;
    }

    createChangePasswordHtml() {
        // policyHtml will be replaced in updateChangePasswordModalWithLoggedInUsersPolicy called from updateChangePasswordPolicy
        var policyHtml = '<div class="unify-change-password-policy"></div>';
        // currentPassword may not be mandatory, add enclosing div for simpel removal
        var components = new Components();
        var currentPasswordHtml = '<div class="unify-change-password-current-password">' + components.createInputHtml({ label: this.translations.internal.CurrentPasswordHeading, type: 'password' }).html + '</div>';
        var newPasswordHtml = '<div class="unify-change-password-new-password">' + components.createInputHtml({ label: this.translations.internal.NewPasswordHeading, type: 'password' }).html + '</div>';
        var repeatNewPasswordHtml = '<div class="unify-change-password-repeated-password">' + components.createInputHtml({ label: this.translations.internal.RepeatNewPasswordHeading, type: 'password' }).html + '</div>';

        return policyHtml + currentPasswordHtml + newPasswordHtml + repeatNewPasswordHtml;
    }

    updateChangePasswordPolicy() {
        // get policy
        ajax({
            context: this,
            callback: this.updateChangePasswordModalWithLoggedInUsersPolicy,
            type: 'GET',
            url: '/unify/password/metadata'
        });
    }

    updateChangePasswordModalWithLoggedInUsersPolicy(data) {
        var requireCurrentPassword = typeof data.requireCurrentPassword === "undefined" ? true : data.requireCurrentPassword;
        var passwordRequirements = typeof data.passwordRequirements === "undefined" ? [] : data.passwordRequirements;
        var passwordRequirementsHtml = '<h4>' + this.context.translations.internal.PasswordRequirementsHeading + '</h4><ul>';
        for (var i = 0, nr = passwordRequirements.length; i < nr; i++) {
            var passwordRequirement = passwordRequirements[i];
            passwordRequirementsHtml += '<li><div data-requirement-id="' + passwordRequirement.requirementId + '" data-is-fulfilled="' + passwordRequirement.isFulfilled + '">' + passwordRequirement.description + '</div></li>';
        }
        passwordRequirementsHtml += '</ul><div class="unify-change-password-validation-messages"></div>';

        var modal = this.context.getChangePasswordModal();
        if (modal === null) {
            return;
        }

        $('.unify-change-password-policy', modal).html(passwordRequirementsHtml);
        // hide current password requirement if not required
        if (requireCurrentPassword === false) {
            $('.unify-change-password-current-password', modal).remove();
        }
    }

    addChangePasswordPolicyOnInputChange() {
        var that = this;
        $('.unify-change-password-new-password input').off('keyup.unify-change-password');
        $('.unify-change-password-new-password input').on('keyup.unify-change-password', { context: that }, that.validateChangePasswordInput);
    }

    addDebounceToChangePasswordSubmitButton() {
        var that = this;
        // below does not seem to work on dynamically added code, even though .on should work, may want to use $('#staticParent').on('click', '.dynamicElement', function() {
        $('[data-unify-debounce-change-password-submit]').off('click.unify-change-password-submit');
        $('[data-unify-debounce-change-password-submit]').on('click.unify-change-password-submit',
            { context: that },
            utils.debounce(function () {
                that.tryChangePassword();
            }, 2000, true));
    }

    addHideValidationMessageOnInputChange() {
        var that = this;
        $('.unify-change-password-current-password input, .unify-change-password-new-password input, .unify-change-password-repeated-password input').off('keyup.unify-hide-validation-messages');
        $('.unify-change-password-current-password input, .unify-change-password-new-password input, .unify-change-password-repeated-password input').on('keyup.unify-hide-validation-message',
            { context: that },
            that.hideValidationMessages);
    }

    submitChangePasswordChange() {
        var modal = this.getChangePasswordModal();
        if (modal === null) {
            return;
        }

        var command = this.getChangePasswordData();
        if (command === null) {
            return;
        }

        ajax({
            context: this,
            callback: this.handleResponseFromServerSideChangePasswordChange,
            data: command,
            type: 'POST',
            url: '/unify/password/change'
        });
    }

    handleResponseFromServerSideChangePasswordChange(data) {
        data = typeof data === "undefined" ? {} : data;
        data.passwordChanged = typeof data.passwordChanged === "undefined" ? false : data.passwordChanged;
        data.errorMessage = typeof data.errorMessage === "undefined" ? '' : data.errorMessage;
        this.context.enableChangePasswordSubmitButton();
        if (data.passwordChanged === true) {
            // alert user it changed and close modal
            var modal = this.context.getChangePasswordModal();
            if (modal !== null) {
                $(modal).modal('hide');
            }
            this.context.showPasswordChangedSuccessfully();
        } else {
            this.context.showPasswordChangedErrorModal(data.errorMessage);
        }
    }

    showPasswordChangedSuccessfully() {
        // show success message
        var modal = new Modal();
        modal.title = 'Password';
        modal.message = 'Password changed successfully';
        modal.closeText = this.translations.common.close;
        modal.show();
    }

    showPasswordChangedErrorModal(message) {
        // show error message
        var modal = new Modal();
        modal.title = 'Password';
        modal.message = message;
        modal.closeText = this.translations.common.close;
        modal.show();
    }

    getChangePasswordModal() {
        for (var i = 0, nr = $('.modal').length; i < nr; i++) {
            var modal = $('.modal')[i];
            if ($(modal).data('change-password') === true) {
                return modal;
            }
        }
        return null;
    }

    getChangePasswordData() {
        var modal = this.getChangePasswordModal();
        if (modal === null) {
            return null;
        }

        var existingPassword = $('.unify-change-password-current-password input', modal).val();
        var newPassword = $('.unify-change-password-new-password input', modal).val();
        var repeatedPassword = $('.unify-change-password-repeated-password input', modal).val();

        // server expects object below command object
        var command = {
            Password: newPassword,
            PasswordRepeated: repeatedPassword
        };

        // existingPassword may not be mandatory, if no input exist do not return data for it
        if (typeof existingPassword !== "undefined") {
            command["ExistingPassword"] = existingPassword;
        }

        return command;
    }

    hideValidationMessages(event) {
        var userClass = event.data.context;
        var modal = userClass.getChangePasswordModal();

        // hide possible validation message
        $('.unify-change-password-validation-messages', modal).hide();
    }

    validateChangePasswordInput(event) {
        var userClass = event.data.context;
        var command = userClass.getChangePasswordData();
        if (command === null) {
            return;
        }
        ajax({
            context: userClass,
            callback: userClass.handleResponseFromServerSideChangePasswordValidate,
            data: command,
            type: 'POST',
            url: '/unify/password/validate'
        });
    }

    tryChangePassword() {
        var command = this.getChangePasswordData();
        if (command === null) {
            return;
        }
        this.disableChangePasswordSubmitButton();
        ajax({
            context: this,
            callback: this.handleResponseFromServerSideChangePasswordValidateWithValidationMessageUpdate,
            data: command,
            type: 'POST',
            url: '/unify/password/validate'
        });
    }

    // will update PasswordRequirementFulfillments
    handleResponseFromServerSideChangePasswordValidate(data) {
        // could get called from ajax or from method in class, 
        // if this.context is set it is from ajax (when using ajax this will point to ajax method)
        // if called from method this could be used
        var userClass = this.context;
        if (typeof userClass === 'undefined') {
            userClass = this;
        }
        var modal = userClass.getChangePasswordModal();
        if (modal === null) {
            return;
        }
        data = typeof data === "undefined" ? {} : data;
        data.isValid = typeof data.isValid === "undefined" ? false : data.isValid;
        // dictionary int bool
        data.passwordRequirementFulfillmentsById = typeof data.passwordRequirementFulfillmentsById === "undefined" ? {} : data.passwordRequirementFulfillmentsById;
        // dictionary string string
        data.validationMessagesByFieldName = typeof data.validationMessagesByFieldName === "undefined" ? {} : data.validationMessagesByFieldName;

        // update the valid classes on the requirements
        for (var propertyName in data.passwordRequirementFulfillmentsById) {
            if (data.passwordRequirementFulfillmentsById.hasOwnProperty(propertyName)) {
                var value = data.passwordRequirementFulfillmentsById[propertyName];
                $('div[data-requirement-id=' + propertyName + ' ]', modal).attr('data-is-fulfilled', value);
            }
        }
    }

    // will update PasswordRequirementFulfillments, show ValidationMessages and submit changes if all ok
    handleResponseFromServerSideChangePasswordValidateWithValidationMessageUpdate(data) {
        var userClass = this.context;
        userClass.handleResponseFromServerSideChangePasswordValidate(data);

        // Show error messages from ValidationMessagesByFieldName
        var messages = [];
        for (var propertyName in data.validationMessagesByFieldName) {
            if (data.validationMessagesByFieldName.hasOwnProperty(propertyName)) {
                var value = data.validationMessagesByFieldName[propertyName];
                messages.push(value);
            }
        }

        var modal = userClass.getChangePasswordModal();
        $('.unify-change-password-validation-messages', modal).html(messages.join('<br>'));

        // show the validation message
        $('.unify-change-password-validation-messages', modal).show();

        // if all fields are ok submit
        if (data.isValid) {
            userClass.submitChangePasswordChange();
        } else {
            // enable submit button
            userClass.enableChangePasswordSubmitButton();
        }
    }

    getChangePasswordSubmitButton() {
        var modal = this.getChangePasswordModal();
        if (modal !== null) {
            return $('button[data-unify-change-password-button]', modal);
        }
        return undefined;
    }

    disableChangePasswordSubmitButton() {
        var button = this.getChangePasswordSubmitButton();
        if (typeof button !== 'undefined') {
            $(button).prop('disabled', true);
            $(button).css('padding-right', '30px');
            $(button).append(`<svg class="unify-spinner--button-inline unify-spinner-appended" viewBox="0 0 64 64">
                                <circle class="unify-spinner__circle" cx="32" cy="32" r="24"></circle>
                             </svg>`);
        }
    }

    enableChangePasswordSubmitButton() {
        var button = this.getChangePasswordSubmitButton();
        if (typeof button !== 'undefined') {
            $(button).prop('disabled', false);
            $(button).css('padding-right', '');
            $('svg', button).remove();
        }
    }

    showChangePasswordDialog(msg) {
        var options = { backdrop: 'static', keyboard: false, show: true };

        // check if the modal has been created (will have added data attribute change-password, see below)
        for (var i = 0, nr = $('.modal').length; i < nr; i++) {
            var modal = $('.modal')[i];
            if ($(modal).data('change-password') === true) {
                $(modal).modal(options);

                // clear all previously inserted input values
                $('input', modal).val('');

                return modal;
            }
        }

        var footer = '<button type="button" class="btn btn-default" data-dismiss="modal">' + this.translations.common.Cancel + '</button><button type="button" data-unify-change-password-button="have-disable" data-unify-debounce-change-password-submit="se js code" class="btn btn-primary">' + this.translations.common.Save + '</button>';
        var components = new Components();
        var dialog = components.createDialogHtml({ footer: footer, body: msg, title: this.translations.internal.ChangePasswordLink });
        $('body').append(dialog.html);
        $(String('#' + dialog.id)).modal(options);
        $('#' + dialog.id).data('change-password', true);

        return dialog;
    }

    /**
    * userGaveConcentToCookiesBeeingUsed stores the consent inside a persistant cookie
    */
    userGaveConcentToCookiesBeeingUsed() {
        var cookiePolicy = new CookiePolicy();
        cookiePolicy.setPersistantCookieConcent();
    }

    async signout(reason = "Manual", forceLeave = false) {
        if (window && window.unify && window.unify.notificationHub) {
            await window.unify.notificationHub.stop();
        }
        if (forceLeave) {
            window.onbeforeunload = undefined;
        }
        window.location.href = this.endpoints.SignOutUri + "?reason=" + reason;
    }

    elevate(level) {
        window.location.href = this.endpoints.SignInUri + "?level=" + level + "&redirectUri=" + encodeURIComponent(window.location.href);
    }
}
export var user = new User();
